import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {
  appInsights: ApplicationInsights;

  constructor(private readonly _router: Router, private readonly _activatedRoute: ActivatedRoute) {
    if (window['environmentVariableConfig']['instrumentationKey']) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: window['environmentVariableConfig']['instrumentationKey'],
          enableAutoRouteTracking: true
        }
      });
      this.appInsights.loadAppInsights();
      this._router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((page: NavigationEnd) => {
        const lastChild = child => child.firstChild ? lastChild(child.firstChild) : child;
        const userAuthenticatedId = sessionStorage.getItem('authId');
        const userName = sessionStorage.getItem('userName');
        if (userName && userAuthenticatedId) {
          this.appInsights.setAuthenticatedUserContext(userAuthenticatedId, userName);
        }
        this.logPageView(lastChild(this._activatedRoute.firstChild).snapshot.data.title, page.url);
      });
    }
  }

  logPageView(name, url): void { // option to call manually
    if(name){
      this.appInsights.trackPageView({
        name: name,
        uri: url
      });
    }
  }
}
